import { render } from "./AccountTypeDeposits.vue?vue&type=template&id=a27422e6"
import script from "./AccountTypeDeposits.vue?vue&type=script&lang=js"
export * from "./AccountTypeDeposits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__